<template>
  <div v-if="list.length" class="notice_box">
    <img class="icon_notice" :src="logo" alt="" />
    <div class="notice_swiper">
      <el-carousel
        height="40px"
        direction="vertical"
        :autoplay="true"
        indicator-position="none"
        :interval="3000"
        :loop="true"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <div class="notice_content can" @click="handleJump(item)">
            <div class="hang1">
              {{ item.title }}
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <i class="icon_arrow el-icon-arrow-right" />
  </div>
</template>

<script>
import request from "@/utils/request";
export default {
  data() {
    return {
      logo: "",
      list: [],
    };
  },
  methods: {
    init(e) {
      this.logo = e.logo;
      this.list = e.list;
    },
    handleJump(e) {
      if (e.type === 1) {
        // 产品风暴
        // this.$openNewTab("/circleV2/storm");
        this.$parent.openPopup({
          type: "stormPopup",
          data: {},
        });
      } else {
        // 期货公司策略
        this.$openNewTab(`/signal?companyId=${e.company_id}&index=0`);
      }
    },
  },
};
</script>

<style scoped>
.notice_box {
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 23px 0 4px;
  background: linear-gradient(90deg, #eaefff 0%, #fafbff 100%);
  border-bottom: 1px solid #dfdfdf;
  font-weight: bold;
  font-size: 14px;
  color: #4571e7;
}

.icon_notice {
  height: 100%;
  display: block;
  flex-shrink: 0;
  margin-right: 6px;
}

.notice_swiper {
  width: 100%;
}

.icon_arrow {
  flex-shrink: 0;
  font-weight: bolder;
}

.notice_content {
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: center;
}
</style>
